import { render, staticRenderFns } from "./ProjectAccessEntry.vue?vue&type=template&id=5bd1743c&scoped=true&"
import script from "./ProjectAccessEntry.vue?vue&type=script&lang=js&"
export * from "./ProjectAccessEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd1743c",
  null
  
)

export default component.exports